import { render, staticRenderFns } from "./socialInsurance.vue?vue&type=template&id=0f40d8f6&scoped=true&"
import script from "./socialInsurance.vue?vue&type=script&lang=js&"
export * from "./socialInsurance.vue?vue&type=script&lang=js&"
import style0 from "./socialInsurance.vue?vue&type=style&index=0&id=0f40d8f6&prod&lang=scss&scoped=true&"
import style1 from "./socialInsurance.vue?vue&type=style&index=1&id=0f40d8f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40d8f6",
  null
  
)

export default component.exports